/**
 * Instance Detail Tabs Configuration
 */

import type { InstanceDetail } from '../../../types'
import InstanceOverview from './InstanceOverview'
import InstanceMonitoring from './InstanceMonitoring'

export const tabs = (instance?: InstanceDetail) => [
    {
        id: 'overview',
        label: 'Overview',
        element: <InstanceOverview instance={instance} />,
    },
    {
        id: 'monitoring',
        label: 'Monitoring',
        element: <InstanceMonitoring />,
    },
]
